import axios from 'axios'
import { API_BASE_URL } from 'services/constants'

/**
 * One-click unsubscribe (MYD-546). Public: plain axios, never the
 * interceptor, because the person following an email link is often not signed
 * in, and the signed token in the URL is the credential.
 */

export interface UnsubscribeLink {
	/** A notification type, or 'all' for every optional email. */
	type: string
	label: string
	/** The recipient, masked: "p•••@example.com". */
	email: string
	/** Whether this email is still on. */
	subscribed: boolean
	paused: boolean
}

const PATH = `${API_BASE_URL}/public/email/unsubscribe`

/** What the link would turn off. Changes nothing. */
export async function getUnsubscribeLink(token: string): Promise<UnsubscribeLink> {
	const { data } = await axios.get<UnsubscribeLink>(PATH, { params: { token } })
	return data
}

/** Turns the link's type off, or with `all`, pauses every optional email. */
export async function unsubscribe(token: string, all = false): Promise<{ type: string; label: string }> {
	const { data } = await axios.post<{ type: string; label: string }>(PATH, all ? { scope: 'all' } : {}, { params: { token } })
	return data
}
